class PushCartNosto extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.nostoElement = this.querySelector('[data-nosto-element]')
    this.loadingText = this.querySelector('[data-loading-message]')

    if (
      (window.innerWidth >= 901 && this.hasAttribute('data-desktop')) ||
      (window.innerWidth < 901 && this.hasAttribute('data-mobile'))
    ) {
      this.nostoElement.id = this.nostoElement.dataset.id
      const container = this.closest('[data-nostoContainer]')

      container.setAttribute('aria-hidden', 'false')
      this.loadingText.setAttribute('aria-hidden', 'true')
    }
  }
}

if (!customElements.get('push-cart-nosto')) {
  customElements.define('push-cart-nosto', PushCartNosto)
}
